// extracted by mini-css-extract-plugin
export default {"page":"H1-z","cartModal":"I1-z","checkout":"J1-z","placeholder":"K1-z","account":"L1-z"};